/**
 * Application modules are split into bundles
 * 3 modes provided - bundles.[mode]
 *
 * `all` - one bundle containing all modules
 * `pack` - one or several modules grouped into several bundles (lazy loaded)
 * `lazy` - each module with it's own bundle (lazy loaded)
 *
 */

import bundles from './bundles.pack'
import docs from '@/../docs/pack'
import LegacyAuth from '@/core/legacy-auth'
import {store} from '@/components/store'

const { allowedComponents, allowedModules } = LegacyAuth

function init() {
  //
  const user = store.state.isLoggedIn

  user && allowedModules()
  let modules = { __get: init }

  if (global.config && global.config.namespace === 'docs') {
    // documentation
    modules = docs.pack(eventHandler)
  } else {
    // main app modules
    const bundleEnum = Object.keys(bundles)

    bundleEnum.forEach(module => {
      const alias = bundles[module] && bundles[module].module && bundles[module].module.alias ||
        bundles[module] && bundles[module].alias || module
      const Module = modules[alias] = bundles[module]

      if (module !== 'lazy' && modules[alias]) {
        modules[alias].on = eventHandler
      }

      if (Module && Module.pack && user) {
        const mergedPack = Object.assign({}, Module.pack, allowedComponents[alias].pack)
        // const packEnum = Object.keys(Module.pack)
        // const packEnum = Object.keys(allowedComponents[alias].pack)
        const packEnum = Object.keys(mergedPack)

        packEnum.forEach(module => {
          const _module = allowedComponents[alias].pack[module]
          let key = _module ? _module.name : module
          const defaultModule = ~key.indexOf('#')

          key = key.replace('#', '')
          const legacy = key[0] !== key[0].toLowerCase()
          const notAllowed = allowedComponents[alias].pack[module] && allowedComponents[alias].pack[module].notAllowed

          if (Module.pack[key]) {
            if (legacy) {
              Module.pack[key].legacy = true
            }

            Module.pack[key].notAllowed = notAllowed
            if (defaultModule) Module.pack[key].defaultModule = true

            modules[key] = Module.pack[key]
            modules[key].on = eventHandler
          }
        })
      }
    })
  }

  return modules
}

function eventHandler (event, callback) {
  const _module = this.module || this

  switch (event) {
    case 'beforeLoad':
      if (typeof _module === 'function') {
        _module.resolved || callback.call(_module())
      }
      break
    case 'afterLoad':
      if (typeof _module === 'function' && _module().then) {
        _module().then((value) => _module.resolved && callback.call(value))
      } else {
        // TODO:
        // callback.call(_module)
      }
      break
  }

  return this
}

export default init()



// WEBPACK FOOTER //
// ./src/components/_modules/index.js